<template>
  <div class="item">
    <div class="item-pic">
      <div
        class="item-pic-core"
        :style="{ backgroundImage: 'url(' + $setPicSize(this.img) + ')' }"
      />
    </div>
    <div class="item-info">
      <div class="item-info-title">
        <span class="item-info-default" v-if="isdefaultSelect">【当前商品】</span>
        <span>{{ title }}</span>
      </div>
      <div class="item-info-content">{{ idType }}: {{ desc }}</div>
      <div class="item-info-price">
        <div v-if="price / 100 > 0">
          ￥<span>{{ price / 100 }}</span>
        </div>
      </div>
      <!-- <div class="item-info-result" :style="{color:bagcolor}">{{ result }}</div> -->
      <!-- <div class="item-info-time">{{ createTime }}</div> -->
    </div>
    <div class="radio-btn" :class="{ active: selected }"></div>
  </div>
</template>

<script>
import setPicSize from '@zz-app/setPicSize'

export default {
  name: 'ListItem',
  data() {
    return {
      bagcolor: 'red'
    }
  },
  props: {
    defaultSelect: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    infoId: {
      type: String,
      default: ''
    },
    img: {
      type: String,
      default: 'https://pic1.zhuanstatic.com/zhuanzh/n_v207c5e15f55224899851612f462744df5.jpg'
    },
    price: {
      type: String,
      default: '0'
    },
    desc: {
      type: String,
      default: ''
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    idType() {
      return '商品描述'
    },
    isdefaultSelect() {
      return this.defaultSelect === this.infoId
    }
  },
  methods: {
    $setPicSize(url) {
      return setPicSize(url, 144, 144)
    }
  }
}
</script>

<style scoped lang="less">
  @import 'index.less';
</style>
